import { api } from "api";
import { UseAuthStatusPayload } from "helpers/useAuthStatus/context";
import Keycloak from "keycloak-js";

// Ends the Platform session and the Keycloak SSO session, in that order.
export const signOutEverywhere = (
	keycloak: Keycloak,
	setRole: UseAuthStatusPayload["setRole"],
): void => {
	const redirectUri = `${window.location.origin}/login`;
	const finish = (): void => {
		setRole("unauthenticated");
		void keycloak.logout({ redirectUri });
	};
	api.signout().then(finish, finish);
};
